export class ApiError extends Error {
    constructor(message = "", { details = "", type = "", code = null } = {}) {
      super(message);
      this.name = "MainError";
      this.details = details;
      this.type = type;
      this.code = code;
    }
  }